module.exports = __webpack_public_path__ + "assets/img/IntelligentInformation.f2f0eb00.png";